export function getWidthBounds(
  possibleSizes: { w: number; h: number }[],
  currentHeight: number,
  expandableSpace: number
) {
  "worklet";
  const sortedWidths = possibleSizes
    .filter(({ w, h }) => currentHeight === h && w <= expandableSpace)
    .map(({ w }) => w)
    .sort();
  if (sortedWidths.length === 0) {
    return {
      min: currentHeight,
      max: currentHeight,
    };
  }
  return {
    min: sortedWidths[0],
    max: sortedWidths[sortedWidths.length - 1],
  };
}
